export const RPS_POSITIVE_THRESHOLD = 1.05;
export const RPS_NEGATIVE_THRESHOLD = 0.95;

export const RPS_FORMULA =
  "RPS = Average individual score received from peers ÷ Average peer received score across the team";

export function rpsColor(value: number | undefined): string | undefined {
  if (value === undefined || !Number.isFinite(value)) return undefined;
  if (value >= RPS_POSITIVE_THRESHOLD) return "var(--color-green)";
  if (value <= RPS_NEGATIVE_THRESHOLD) return "var(--color-red)";
  return undefined;
}

// Window for the continuous red→yellow→green gradient applied to the RPS
// stat. The score is a ratio centred on 1.0, so the window is symmetric:
// 0.8 saturates to red, 1.0 is the yellow midpoint, 1.2 saturates to green.
export const RPS_COLOR_MIN = 0.8;
export const RPS_COLOR_MAX = 1.2;

// Map an RPS ratio onto the 0–1 proportion that `getColor` (the score-ring
// gradient) expects, with 1.0 landing on 0.5 (yellow). Values outside the
// window clamp to the saturated ends.
export function rpsProportion(value: number): number {
  const clamped = Math.max(RPS_COLOR_MIN, Math.min(value, RPS_COLOR_MAX));
  return (clamped - RPS_COLOR_MIN) / (RPS_COLOR_MAX - RPS_COLOR_MIN);
}
